import { Field, FormRenderProps } from "@progress/kendo-react-form"
import styles from '../../../styles/estrategiaAdaptacao/EstrategiaAdaptacao.module.scss';
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { coordenadasPoligono, entidades, get, post } from "../../../services/utils";
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { filterBy } from "@progress/kendo-data-query";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import FieldsetCombosLocalizacao from "../../localizacao/FieldsetCombosLocalizacao";
import ValidatedIdentificacaoCheckbox from "./ValidationComponentes/ValidatedIdentificacaoCheckbox";
import { requiredFieldValidator } from "../../../validations/ocorrencia";
import useVisibleColumns, { Key } from "../../../hooks/useVIsibleColumns";
import SessionStorageService from "../../../services/SessionStorageService";
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent, GridToolbar } from "@progress/kendo-react-grid";
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import { ResultadoValorUsoDoSoloCommandGridCell } from "../../usosdosolo/ResultadoValorUsoDoSoloCommandGridCell";
import { useValorUsoDoSoloStore } from "../../../stores/valorUsoDoSolo";
import DetalheValorUsoDoSolo from "../../usosdosolo/DetalheValorUsoDoSolo";
import { Dialog } from '@progress/kendo-react-dialogs'
import VisualizadorColunas from "../../Generico/VisualizadorColunas ";
import { ResultadoAcaoCommandGridCell } from "../../intervencao/ResultadoAcaoCommandGridCell";
import { process } from '@progress/kendo-data-query';
import { CONSULTAR_ACAO, PESQUISAR_ACAO } from "../../../utils/constants";
import { useCommonStore } from "../../../stores/common";
import html2canvas from "html2canvas";
import ReactGA from 'react-ga4';
import CustomGridCell from '../../ocorrencia/CustomGridCell';
import moment from 'moment';

type IProps = {
    idForm: number
    initialValuesForm?: any
    viewMode?: boolean
    colunasVisiveis?: any
    onChange?: any
    setActiveAcao?: any
    initialized?: any
    isMobile?: boolean
}

type PageState = {
    skip: number
    take: number
}

const AcaoEstrategiaAdaptacao = forwardRef(({
    idForm, initialValuesForm, viewMode, colunasVisiveis, onChange, setActiveAcao, initialized, isMobile
}: IProps, ref: React.Ref<any>) => {

    const [acoes, setAcoes] = useState([])

    const initialDataState: PageState = { skip: 0, take: 10 }
    const [page, setPage] = useState<PageState>(initialDataState)
    const [pageSizeValue, setPageSizeValue] = useState<number | string | undefined>()


    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/AcaoEstrategiaAdaptacao" });
    }, []);

    useEffect(() => {
        SessionStorageService.setItem("dataGridAcoesEA", initialValuesForm?.acoes);
        loadInterface();
        initialized(idForm);
        onChange()
    }, []);

    useEffect(() => {
        loadInterface();
        onChange()
    }, [initialValuesForm]);


    /**
     * Define exposed component functions
     **/
    useImperativeHandle(ref, () => ({
        getValues: () => acoes,
        isValid: () => { return acoes ? true : false },
        showInvalidMessage: () => { return; }
    }));


    const loadInterface = async () => {

        postMessage({ type: 'showLoader' }, '*')

        try {

            const idsAcao = initialValuesForm?.acoesAtivas.map((o: { id_acao: number }) => o.id_acao);

            if (idsAcao.length > 0) {
                const iframe: any = document.getElementById('iframeGeoPortal');

                initialValuesForm?.acoesAtivas.map((acao: any) => {
                    acao.id = acao.id_acao;
                });

                const columns = colunasVisiveis?.columns?.filter((x: { show: any, field: string }) => x.show && x.field != 'analise_ativo' ).map((option: { field: any; title: any }) => ({
                    field: option.field,
                    title: option.title
                }));

                iframe.contentWindow?.postMessage(
                    {
                        type: 'SiarlDefineExtraLayerTooltipColumns', value: {
                            layer: 'Siarl:intAcao', columns: columns
                        }
                    }, '*'
                );

                iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoSearch", value: { ids: idsAcao, result: initialValuesForm?.acoesAtivas, active: false } }, '*');
            }

            setAcoes(initialValuesForm?.acoes?.sort((acao1: any, acao2: any) => acao2.valor - acao1.valor));

            saveScreenById("imgsAcao")

        } catch (error) {
            postMessage({ type: 'errorMsg', value: { message: "Não foi possivel efetuar esta operação" } }, '*')
        } finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }

    const handleLocationClickById = (acaoLocal: Record<string, any>) => async () => {
        const id = acaoLocal.id_acao;
        const iframe: any = document.getElementById('iframeGeoPortal')
        iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoCenter", value: [id] }, '*')
        restoreView();
    }

    const acaoCustomCell = (props: GridCellProps) => (
        <ResultadoAcaoCommandGridCell
            {...props}
            onLocationClick={handleLocationClickById}
        />
    )

    const restoreView = useCommonStore(state => state.restoreView)

    const saveScreenById = async (key: string) => {
        let mapImage: any = undefined;
        
        if (!window.location.href.includes('localhost')) {

            const mapIframe = document.querySelector(
                '#iframeGeoPortal'
            ) as HTMLIFrameElement

            const mapIframeInnerContent =
                mapIframe.contentWindow?.document.querySelector(
                    'section.content'
                ) as HTMLElement

            const generatedImage = await html2canvas(mapIframeInnerContent)
            mapImage = generatedImage.toDataURL()
        }
        SessionStorageService.setItem(key, JSON.stringify({
            img_mapa_acao: mapImage
        }))
    }

    const styleCells = { 'paddingLeft': '5px', 'paddingRight': '5px', 'textAlign': 'center' }

    const anoAnaliseCell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={{ ...props.style, ...styleCells }}>
                Ano de análise: <br /><span>{initialValuesForm?.anoReferencia ?? '----'}</span>
            </td>
        );
    };

    const totalCell = (props: any) => {
        const totalValor = acoes.reduce((acc: any, acoe: { valor: any, analise_ativo: boolean }) => acc + (acoe.analise_ativo ? acoe.valor : 0), 0);

        return (
            <td colSpan={props.colSpan} style={{ ...props.style, ...styleCells }}>
                Valor total: <br /><span>{getFormatedEurNumber(totalValor)}</span>
            </td>
        );
    };

    const responsiveSummaryCell = () => {

        const styleColumn: any = { textAlign: 'center', flex: 1, padding: '10px', boxSizing: 'border-box' };
        const styleTitle = { fontWeight: 'bold' };
        const totalValor = acoes.reduce((acc: any, acoe: { valor: any; }) => acc + acoe.valor, 0);

        return (
            <div style={{ display: 'flex', marginTop: '20px' }}>
                <div style={styleColumn}><span style={styleTitle}>Ano de análise: </span><br/><span>{initialValuesForm?.anoReferencia ?? '----'}</span></div>
                <div style={styleColumn}><span style={styleTitle}>Valor total: </span><br/><span>{getFormatedEurNumber(totalValor || 0)}</span></div>
            </div>
        )
    }

    const getFormatedEurNumber = (value: any) => {
        return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value);
    }

    const getCurrentColumn = (columnName: string) => {
        switch (columnName) {
            case "anoAnalise":
                return anoAnaliseCell;
            case "total":
                return totalCell;
            default:
        }
    }

    const handlePageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;
        const take = targetEvent.value === "All" ? acoes.length : event.page.take;

        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take
        });
    };

    const CustomCell = (props: GridCellProps) => (
        <CustomGridCell
            {...props}
            onMouseEnter={handleRowMouseEnterById}
            onMouseLeave={handleRowMouseLeaveById}
        />
    )

    const activeCell = (props: any) => {
        return (
            <td className={props.className}
                onMouseEnter={() => handleRowMouseEnterById(props.dataItem)}
                onMouseLeave={() => handleRowMouseLeaveById(props.dataItem)}>
                <Checkbox
                    checked={props.dataItem.analise_ativo}
                    onChange={(e) => setActiveAcao(props.dataItem, e.value)}
                    disabled={viewMode}
                />
            </td>
        );
    };


    const handleRowMouseEnterById = (item: any) => {
        const id = item.id_acao ?? null;

        if (id && item.analise_ativo) {
            const iframe: any = document.getElementById('iframeGeoPortal');
            iframe.contentWindow?.postMessage({ type: 'SiarlIntAcaoHighlight', value: [id] }, '*')
        }
    }

    const handleRowMouseLeaveById = (item: any) => {
        const id = item.id_acao ?? null;

        if (id && item.analise_ativo) {
            const iframe: any = document.getElementById('iframeGeoPortal');
            iframe.contentWindow?.postMessage({ type: 'SiarlIntAcaoHighlightRemove', value: [id] }, '*')
        }
    }

    const dateCell = (props: any) => (
        <td
            className={styles.eaGridColumnCenteredContent}
            onMouseEnter={() => handleRowMouseEnterById(props.dataItem)}
            onMouseLeave={() => handleRowMouseLeaveById(props.dataItem)}
        >{props.dataItem[props.field] ? moment(props.dataItem[props.field]).format('DD-MM-YYYY') : ''}</td>
    )

    const getCell = (cellName: string) => {
        switch (cellName) {
            case "activeCell":
                return activeCell;
            case "dateCell":
                return dateCell;
            default:
        }
        return null
    }

    return (
        <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
            <Grid
                sortable={true}
                scrollable="scrollable"
                onPageChange={handlePageChange}
                data={acoes?.slice(page.skip, page.take + page.skip).sort((a: any, b: any) => b.valor - a.valor).map((acoe: any) => (
                    {
                        ...acoe,
                        valor: new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(acoe.valor)
                    }
                ))}
                cells={{ data: CustomCell }}
                pageable={{
                    buttonCount: 5,
                    info: true,
                    type: 'numeric',
                    pageSizes: true,
                    previousNext: true
                }}
                fixedScroll={true}
                rowHeight={50}
                skip={page.skip}
                take={page.take}
                total={acoes.length}
            >
                <GridColumn cell={acaoCustomCell} width={20} />
                {colunasVisiveis?.columns?.map((column: any, i: number) => {
                    return (
                        column.show && (
                            <GridColumn key={i} field={column.field} width={column.width} title={column.title} cell={column.cell ? getCell(column.cell) : column.cell} className={column.className} headerCell={column.headerCell} footerCell={getCurrentColumn(column.footerCell)} />
                        )
                    );
                })}
            </Grid>
            {isMobile ? responsiveSummaryCell() : <></>}
        </div>
    );
});

export default AcaoEstrategiaAdaptacao;